import { useEffect, useState } from "react";
import styles from "./driverJobDelivery.module.css";
import dayjs from "dayjs";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, Snackbar, Alert, Typography, Checkbox, Dialog, Tooltip } from "@mui/material";
import { Add, PrintOutlined } from "@mui/icons-material";
import TablePaginationComponent from "../../components/TablePagination";
import { Close, ArrowForwardOutlined } from "@mui/icons-material";
import axios from "axios";
import Loader from "../../components/Loader";
import { authData, withAdminAuth } from "../../components/GetAuth";
import { ComponentToPrint } from "./driverJobDeliveryPrint";
import { ComponentToPrintList } from "./driverJobDeliveryListPrint";
import { useReactToPrint, ReactToPrint, PrintContextConsumer } from "react-to-print";
import { Edit3, Plus, Search } from "react-feather";
import { useRef } from "react";
import { useCallback } from "react";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import PageHeader from "../../components/PageHeader";
import AddDriverForm from "../../components/popups/AddDriverForm";
import UpdateNotePopup from "../../components/popups/UpdateNotePopup";
import ReassignDeliveryDriverPopup from "../../components/popups/ReassignDeliveryDriverPopup";
import DeliveryTableLoader from "./DeliveryTableLoader";

const ButtonArea = ({ data, selected, setSnackbarType, setSnackbarOpen, setSnackbarMessage }) => {
  const componentRef = useRef();

  const Export = ({ onExport }) => (
    <Button onClick={(e) => onExport(e.target.value)} className={styles.TableAddBU}>
      Export to CSV
    </Button>
  );

  const convertArrayOfObjectsToCSV = (array) => {
    let result = "";

    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const keys = ["driver_name", "booking_id", "address", "contact_no", "recepient_name", "order_status", "delivery_notes", "assigned_date"];
    const labels = {
      driver_name: "Driver Name",
      booking_id: "Booking Id",
      address: "Address",
      contact_no: "Contact No",
      recepient_name: "Recepient Name",
      order_status: "Order Status",
      delivery_notes: "Delivery Notes",
      assigned_date: "Assigned Date",
    };

    keys.forEach((key) => {
      result += labels[key] ?? key;
      result += columnDelimiter;
    });
    result += lineDelimiter;

    array.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  };

  const downloadCSV = useCallback(() => {
    let newArray = data.map((row) => {
      return {
        driver_name: row?.delivery_driver?.name,
        booking_id: row?.booking_id,
        address: row?.recipient_details?.address.replace(/,/g, ""),
        contact_no: row?.recipient_details?.phone,
        recepient_name: row?.recipient_details?.name,
        order_status: row?.payment_status === 1 || row?.payment_status === "1" ? "Paid" : "Unpaid",
        delivery_notes: row?.delivery_note,
        assigned_date: dayjs(row?.delivery_driver?.updated_at).format("DD/MM/YYYY"),
      };
    });

    const link = document.createElement("a");
    let csv = convertArrayOfObjectsToCSV(newArray);
    if (csv == null) return;

    const filename = "driver-jobs.csv";

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }
    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  }, [data]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const componentRef2 = useRef();

  const handlePrint2 = useReactToPrint({
    content: () => componentRef2.current,
  });

  const assignDrivers = () => {
    if (selected.length === 0) {
      setSnackbarType("error");
      setSnackbarOpen(true);
      setSnackbarMessage("Please select item(s)");

      return false;
    }

    handlePrint2();
  }

  const newBookingData = data?.filter(i => selected.indexOf(i?.id) > -1);

  return (
    <>
      <Export onExport={() => downloadCSV()} />
      {/*<Button onClick={handlePrint} className={styles.TableAddBU}>
        Print Bookings
      </Button>
      <div style={{ display: "none" }}>
        <ComponentToPrintList ref={componentRef} data={data} />
      </div>}*/}

      <div style={{ display: "none" }}>
        <ComponentToPrint ref={componentRef2} bookingData={newBookingData} />
      </div>
      <ReactToPrint content={componentRef2}>
        <PrintContextConsumer>
          {({ handlePrint }) => (
            <Button className={styles.TableAddBU} onClick={assignDrivers}>
              Print Bookings
            </Button>
          )}
        </PrintContextConsumer>
      </ReactToPrint>
    </>
  );
};

const DriverJobDelivery = () => {
  const auth = authData();
  const componentRef = useRef();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "", date: null });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [selected, setSelected] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [driverFormOpen, setDriverFormOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [selectBooking, setSelectBooking] = useState(null);
  const [noteData, setNoteData] = useState(null);

  const { websiteData } = useWebsite();
  useSiteBranding("Delivery Driver Job", websiteData);

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchBookings = () => {
      setContentLoading(true);
      axios
        .get(process.env.REACT_APP_API_URL + "v1/delivery/assigned-bookings", {
          headers: {
            Authorization: `Bearer ${API_TOKEN}`,
          },
        })
        .then((response) => {
          setContentLoading(false);
          setAllData(response.data.data);
        })
        .catch((error) => {
          setContentLoading(false);
        });
    };

    fetchBookings();
  }, [API_TOKEN]);

  useEffect(() => {
    let filterredTempData = allData;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return (
          item?.delivery_driver?.name.toLowerCase().includes(inputVal) ||
          item?.booking_id.toLowerCase().includes(inputVal) ||
          item?.recipient_details?.address.toLowerCase().includes(inputVal) ||
          item?.recipient_details?.phone.toLowerCase().includes(inputVal) ||
          item?.recipient_details?.name.toLowerCase().includes(inputVal)
        );
      });
    }

    setFilteredData(filterredTempData);
  }, [allData, filterVars]);

  const selectRowEvent = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const assignDrivers = () => {
    if (selected.length === 0) {
      setSnackbarType("error");
      setSnackbarOpen(true);
      setSnackbarMessage("Please select item(s)");

      return false;
    }
    let postData = { bookingIds: selected };

    axios
      .post(process.env.REACT_APP_API_URL + "v1/delivery/make-as-delivered", postData, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        },
      })
      .then((response) => {
        if (response.data.status === "SUCCESS") {
          axios(process.env.REACT_APP_API_URL + "v1/delivery/assigned-bookings", {
            headers: {
              Authorization: `Bearer ${API_TOKEN}`,
            },
          })
            .then((response) => {
              if (response.data.status === "SUCCESS") {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType("success");
                setAllData(response.data.data);
                setSelected([]);
              } else {
                setLoading(false);
              }
            })
            .catch((error) => {
              setLoading(false);
            });
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const onAssign = () => {
    setSnackbarType("success");
    setSnackbarOpen(true);
    setSnackbarMessage("Driver assigned successfully.");

    axios
      .get(process.env.REACT_APP_API_URL + "v1/delivery/assigned-bookings", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        },
      })
      .then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setContentLoading(false);
      });
  };

  const isPaid = (item) => item?.payment_status === 1 || item?.payment_status === "1";

  const pagedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <Loader open={loading} setOpen={setLoading.bind(this)} />
      <div className={styles.MainDiv}>
        <PageHeader title="Delivery" trail={[{ label: "Driver Job" }]} />
        <div className={styles.MainCard}>
          {contentLoading && <DeliveryTableLoader rows={rowsPerPage} />}

          {!contentLoading && (
            <>
              <div className={styles.TableFilterHead}>
                <div className={styles.DataTableSearch}>
                  <Search className={styles.SearchIcon} />
                  <TextField
                    className={styles.SearchInput}
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    type="text"
                    placeholder="Search driver, booking, recipient..."
                    value={filterVars?.searchKey}
                    onChange={(e) =>
                      setFilterVars((prev) => {
                        return { ...prev, searchKey: e.target.value };
                      })
                    }
                  />
                  {filterVars?.searchKey !== "" && (
                    <Button
                      type="button"
                      className={styles.CloseBU}
                      onClick={(e) =>
                        setFilterVars((prev) => {
                          return { ...prev, searchKey: "" };
                        })
                      }
                    >
                      <Close />
                    </Button>
                  )}
                </div>
                <div className={styles.TableFilterBUSec}>
                  {selected.length > 0 && (
                    <Typography className={styles.SelectedCount} component="span">
                      {selected.length} selected
                    </Typography>
                  )}
                  <ButtonArea data={filteredData} selected={selected} setSnackbarType={setSnackbarType.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} />
                  <Button className={styles.PrimaryBU} onClick={(e) => assignDrivers()}>
                    <Add />
                    Mark delivered
                  </Button>
                </div>
              </div>

              {/* ============ Desktop table ============ */}
              <div className={styles.CusTable}>
                <TableContainer component={Paper} elevation={0}>
                  <Table sx={{ minWidth: 650 }} aria-label="driver job delivery table">
                    <TableHead>
                      <TableRow>
                        <TableCell className={styles.TableHeaderCell} padding="checkbox">
                          <Checkbox
                            color="primary"
                            indeterminate={selected?.length > 0 && selected?.length < filteredData?.length}
                            checked={filteredData?.length > 0 && selected?.length === filteredData?.length}
                            onChange={(e) => {
                              if (e.target.checked) {
                                const newSelected = filteredData.map((n) => n.id);
                                setSelected(newSelected);
                                return;
                              }
                              setSelected([]);
                            }}
                          />
                        </TableCell>
                        <TableCell className={styles.TableHeaderCell}>Driver</TableCell>
                        <TableCell className={styles.TableHeaderCell}>Booking Id</TableCell>
                        <TableCell className={styles.TableHeaderCell}>Address</TableCell>
                        <TableCell className={styles.TableHeaderCell}>Contact</TableCell>
                        <TableCell className={styles.TableHeaderCell}>Recipient</TableCell>
                        <TableCell className={styles.TableHeaderCell}>Status</TableCell>
                        <TableCell className={styles.TableHeaderCell}>Delivery Note</TableCell>
                        <TableCell className={styles.TableHeaderCell}>Assigned</TableCell>
                        <TableCell className={styles.TableHeaderCell}>Actions</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {pagedData.map((item) => {
                        const isItemSelected = selected.indexOf(item?.id) !== -1;

                        return (
                          <TableRow key={item?.id} className={styles.TableRow}>
                            <TableCell padding="checkbox">
                              <Checkbox
                                color="primary"
                                checked={isItemSelected}
                                onClick={(e) => selectRowEvent(item?.id)}
                                aria-checked={isItemSelected}
                              />
                            </TableCell>
                            <TableCell>{item?.delivery_driver?.name}</TableCell>
                            <TableCell>{item?.booking_id}</TableCell>
                            <TableCell>{item?.recipient_details?.address}</TableCell>
                            <TableCell>{item?.recipient_details?.phone}</TableCell>
                            <TableCell>{item?.recipient_details?.name}</TableCell>
                            <TableCell>
                              <span className={`${styles.StatusBU} ${isPaid(item) ? styles.DisaBU : ""}`}>
                                {isPaid(item) ? "Paid" : "Unpaid"}
                              </span>
                            </TableCell>
                            <TableCell>
                              {item?.delivery_note ? (
                                <>
                                  <p className={styles.NoteText}>{item?.delivery_note}</p>
                                  <button
                                    className={styles.AddNote}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setNoteModalOpen(true);
                                      setNoteData(item?.delivery_note);
                                      setSelectBooking(item);
                                    }}
                                  >
                                    <Edit3 size={12} />
                                    Update
                                  </button>
                                </>
                              ) : (
                                <button
                                  className={styles.AddNote}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setNoteModalOpen(true);
                                    setNoteData(null);
                                    setSelectBooking(item);
                                  }}
                                >
                                  <Plus /> Add note
                                </button>
                              )}
                            </TableCell>
                            <TableCell>{dayjs(item?.delivery_driver?.delivered_date).format("DD/MM/YYYY")}</TableCell>
                            <TableCell>
                              <div className={styles.ActionDiv}>
                                <Tooltip title="Print">
                                  <span>
                                    <div style={{ display: "none" }}>
                                      <ComponentToPrint ref={(el) => (componentRef[item?.id] = el)} bookingData={[item]} />
                                    </div>
                                    <ReactToPrint content={() => componentRef[item?.id]}>
                                      <PrintContextConsumer>
                                        {({ handlePrint }) => (
                                          <Button className={styles.ActionBU} onClick={handlePrint}>
                                            <PrintOutlined />
                                          </Button>
                                        )}
                                      </PrintContextConsumer>
                                    </ReactToPrint>
                                  </span>
                                </Tooltip>
                                <Tooltip title="Re-assign or un-assign">
                                  <Button
                                    className={styles.ActionBU}
                                    onClick={(e) => {
                                      setFormOpen(true);
                                      setSelectedId(item?.id);
                                    }}
                                  >
                                    <ArrowForwardOutlined />
                                  </Button>
                                </Tooltip>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      {filteredData.length === 0 && (
                        <TableRow>
                          <TableCell className={styles.EmptyCell} colSpan={10}>
                            No deliveries found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>

                  </Table>
                </TableContainer>

                {filteredData?.length > 0 && (
                  <div className={styles.PaginationWrap}>
                    <TablePaginationComponent
                      count={filteredData?.length}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={paginationChangePage}
                      handleChangeRowsPerPage={paginationChangeRowsPerPage}
                    />
                  </div>
                )}
              </div>

              {/* ============ Mobile card list ============ */}
              <div className={styles.CardList}>
                {pagedData.map((item) => {
                  const isItemSelected = selected.indexOf(item?.id) !== -1;

                  return (
                    <div
                      key={item?.id}
                      className={`${styles.BookingCard} ${isItemSelected ? styles.CardSelected : ""}`}
                    >
                      <div className={styles.CardTopRow}>
                        <Checkbox
                          className={styles.CardCheckbox}
                          color="primary"
                          checked={isItemSelected}
                          onClick={(e) => selectRowEvent(item?.id)}
                        />
                        <div className={styles.CardHeading}>
                          <p className={styles.CardBookingId}>{item?.booking_id}</p>
                          <p className={styles.CardDriverName}>{item?.delivery_driver?.name}</p>
                        </div>
                        <span className={`${styles.StatusBU} ${isPaid(item) ? styles.DisaBU : ""}`}>
                          {isPaid(item) ? "Paid" : "Unpaid"}
                        </span>
                      </div>

                      <div className={styles.CardGrid}>
                        <div className={styles.CardField}>
                          <span className={styles.CardFieldLabel}>Recipient</span>
                          <span className={styles.CardFieldValue}>{item?.recipient_details?.name}</span>
                        </div>
                        <div className={styles.CardField}>
                          <span className={styles.CardFieldLabel}>Contact</span>
                          <span className={styles.CardFieldValue}>{item?.recipient_details?.phone}</span>
                        </div>
                        <div className={styles.CardField}>
                          <span className={styles.CardFieldLabel}>Address</span>
                          <span className={styles.CardFieldValue}>{item?.recipient_details?.address}</span>
                        </div>
                        <div className={styles.CardField}>
                          <span className={styles.CardFieldLabel}>Assigned</span>
                          <span className={styles.CardFieldValue}>
                            {dayjs(item?.delivery_driver?.delivered_date).format("DD/MM/YYYY")}
                          </span>
                        </div>
                      </div>

                      <div className={styles.CardFooterRow}>
                        {item?.delivery_note ? (
                          <div>
                            <p className={styles.NoteText}>{item?.delivery_note}</p>
                            <button
                              className={styles.AddNote}
                              onClick={(e) => {
                                e.preventDefault();
                                setNoteModalOpen(true);
                                setNoteData(item?.delivery_note);
                                setSelectBooking(item);
                              }}
                            >
                              Update note
                            </button>
                          </div>
                        ) : (
                          <button
                            className={styles.AddNote}
                            onClick={(e) => {
                              e.preventDefault();
                              setNoteModalOpen(true);
                              setNoteData(null);
                              setSelectBooking(item);
                            }}
                          >
                            <Plus /> Add note
                          </button>
                        )}

                        <div className={styles.CardActions}>
                          <div style={{ display: "none" }}>
                            <ComponentToPrint ref={(el) => (componentRef[item?.id] = el)} bookingData={[item]} />
                          </div>
                          <ReactToPrint content={() => componentRef[item?.id]}>
                            <PrintContextConsumer>
                              {({ handlePrint }) => (
                                <Button className={styles.ActionBU} onClick={handlePrint}>
                                  <PrintOutlined />
                                </Button>
                              )}
                            </PrintContextConsumer>
                          </ReactToPrint>
                          <Button
                            className={styles.ActionBU}
                            onClick={(e) => {
                              setFormOpen(true);
                              setSelectedId(item?.id);
                            }}
                          >
                            <ArrowForwardOutlined />
                          </Button>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {filteredData.length === 0 && <div className={styles.EmptyState}>No deliveries found</div>}

                {filteredData?.length > 0 && (
                  <div className={styles.PaginationWrap}>
                    <TablePaginationComponent
                      count={filteredData?.length}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={paginationChangePage}
                      handleChangeRowsPerPage={paginationChangeRowsPerPage}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      <Dialog open={formOpen} onClose={(e) => setFormOpen(false)} fullWidth maxWidth="sm">
        <ReassignDeliveryDriverPopup
          setLoading={setLoading.bind(this)}
          modalClose={setFormOpen.bind(this)}
          bookingIds={selectedId}
          onSubmit={onAssign.bind(this)}
        />
      </Dialog>

      <Dialog open={driverFormOpen} onClose={(e) => setFormOpen(false)} fullWidth maxWidth="sm">
        <AddDriverForm
          setFormOpen={setDriverFormOpen.bind(this)}
          setAllData={setAllData.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          setSnackbarMessage={setSnackbarMessage.bind(this)}
          setSnackbarType={setSnackbarType.bind(this)}
          setLoading={setLoading.bind(this)}
          editData={null}
        />
      </Dialog>

      <Dialog fullWidth maxWidth="sm" open={noteModalOpen} onClose={(e) => setNoteModalOpen(false)}>
        <UpdateNotePopup
          setNoteModalOpen={setNoteModalOpen.bind(this)}
          noteData={noteData}
          selectBooking={selectBooking}
          setLoading={setLoading.bind(this)}
          setAllData={setAllData.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          setSnackbarMessage={setSnackbarMessage.bind(this)}
          setSnackbarType={setSnackbarType.bind(this)}
        />
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={(e) => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={(e) => setSnackbarOpen(false)} severity={snackbarType} variant="filled" sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default withAdminAuth(DriverJobDelivery);